/* VIP Sale 2026 – vip-cart-lines.js (Markus 21.10.2026, ersetzt die schwarze VIP-Box im Warenkorb).
   Zeigt in aktiver VIP-Phase (auch Vorschau-Simulation ?vip_phase=…) den VIP-Rabatt
   a) pro Warenkorbzeile: Chip „VIP −25 %“ + Preis durchgestrichen → reduzierter Preis (cent-genau),
   b) unter der Zwischensumme: Zeile „VIP-Rabatt <Phase> (25 %)  −X €“ (Schwarz/Gold) + Zwischensumme reduziert.
   Echter Rabatt (ab So 25.10. 08:00: Shopify zieht den automatischen Bestellrabatt ab, cart_level_discount_applications):
   - nichts doppelt abziehen: die Zwischensumme kommt dann vom Theme (bereits reduziert, Original durchgestrichen),
   - die rote Rabatt-Pill des Themes mit dem Shopify-Rabatttitel („VIP Early Access – 33 % ab 3.000 €“) wird ausgeblendet und
     durch dieselbe Schwarz/Gold-Zeile ersetzt – Betrag = echter Rabattbetrag aus Shopify (Markus 21.10.: Optik vorher = nachher,
     getestet mit Testrabatt ab 50.000 €).
   Basis = VIP.cartBasisCents(cart) (ohne Gratis-Teppich), Satz = VIP.tierFor(basis).pct.
   Drawer-Footer/Items werden von cart.js per innerHTML ersetzt → idempotent bei vip:cart / vip:phase / cart:updated. */
(function () {
  if (window.__vipCartLines) return;
  window.__vipCartLines = true;
  var LABELS = {early: 'VIP Early Access', vipday: 'VIP-Day', day2: 'Tag 2', day3: 'Tag 3'};
  var ICON = '<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-discount icon--extra-small" viewBox="0 0 15 15" fill="none" aria-hidden="true"><path d="M2.3 7.6a.4.4 0 0 1-.1-.3V2.2h5.1c.1 0 .2 0 .3.1L13 7.7a.4.4 0 0 1 0 .6l-4.6 4.7a.4.4 0 0 1-.6 0z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><circle cx="4.9" cy="4.9" r=".9" fill="currentColor"/></svg>';
  function fmt(c) {
    try { if (window.VIP && VIP.formatEUR) return VIP.formatEUR(c); } catch (e) {}
    return (c / 100).toLocaleString('de-DE', {style: 'currency', currency: 'EUR'});
  }
  function isGift(item) {
    var p = item && item.properties;
    return !!(p && (p._vip_gift || p['_vip_gift']));
  }
  function isVipTitle(t) {
    t = String(t || '');
    return /^VIP\b/i.test(t) && !/Teppich/i.test(t);
  }
  function state(cart) {
    try {
      var V = window.VIP, ph = V && V.phase && V.phase();
      cart = cart || (V && V.cart);
      if (!V || !ph || !ph.active || !cart || !cart.item_count) return null;
      var basis = V.cartBasisCents(cart), t = V.tierFor(basis);
      if (!t || !t.pct) return null;
      var apps = (cart.cart_level_discount_applications || []).filter(function (a) { return isVipTitle(a.title); });
      var realDisc = apps.reduce(function (s, a) { return s + Number(a.total_allocated_amount || 0); }, 0);
      var real = apps.length > 0 || Number(cart.total_price) < Number(cart.original_total_price);
      return {cart: cart, pct: t.pct, basis: basis, label: LABELS[ph.key] || ph.label || 'VIP Sale', real: real,
        titles: apps.map(function (a) { return String(a.title); }),
        disc: real && realDisc > 0 ? realDisc : Math.round(basis * t.pct / 100)};
    } catch (e) { return null; }
  }
  function restore(root) {
    root.querySelectorAll('[data-vip-orig]').forEach(function (el) { el.innerHTML = el.getAttribute('data-vip-orig'); el.removeAttribute('data-vip-orig'); });
    root.querySelectorAll('.vip-line-disc, .vip-sum-row').forEach(function (el) { el.remove(); });
    root.querySelectorAll('.vip-hide-pill').forEach(function (el) { el.classList.remove('vip-hide-pill'); });
  }
  function paintLines(root, s) {
    var items = s.cart.items || [];
    root.querySelectorAll('.cart-item').forEach(function (li) {
      var m = (li.id || '').match(/-(\d+)$/);
      var item = m ? items[Number(m[1]) - 1] : null;
      if (!item) {
        var vid = li.getAttribute('data-variant-id');
        item = items.filter(function (x) { return String(x.variant_id) === String(vid) && !isGift(x); })[0];
      }
      if (!item || isGift(item)) return;
      var prices = li.querySelector('.cart-item__prices');
      var price = prices && prices.querySelector('.price');
      if (!prices || !price) return;
      if (!prices.querySelector('.vip-line-disc')) {
        var ul = document.createElement('ul');
        ul.className = 'vip-line-disc cart-item__discounts discounts list-unstyled flex justify-end flex-wrap gap-1';
        ul.setAttribute('role', 'list');
        ul.innerHTML = '<li class="discount text-sm-extra font-body-bold inline-flex items-center">' + ICON + '<span>VIP −' + s.pct + ' %</span></li>';
        prices.insertBefore(ul, prices.firstChild);
      }
      if (!price.hasAttribute('data-vip-orig')) price.setAttribute('data-vip-orig', price.innerHTML);
      var unit = Number(item.final_price), red = Math.round(unit * (100 - s.pct) / 100);
      price.classList.add('price--on-sale');
      price.innerHTML = '<span class="visually-hidden">Regulärer Preis</span><s class="font-body text-sm text-subtext">' + fmt(unit) +
        '</s> <span class="visually-hidden">VIP-Preis</span><span class="price__sale">' + fmt(red) + '</span>';
      /* /cart: Spalte „Gesamt“ pro Zeile */
      var tot = li.querySelector('.cart-item__total');
      if (tot) {
        if (!tot.hasAttribute('data-vip-orig')) tot.setAttribute('data-vip-orig', tot.innerHTML);
        var line = Number(item.final_line_price), lred = Math.round(line * (100 - s.pct) / 100);
        tot.innerHTML = '<s class="font-body text-sm text-subtext">' + fmt(line) + '</s><br><span class="font-body-bolder">' + fmt(lred) + '</span>';
      }
    });
  }
  function hideThemePills(root, s) {
    if (!s.real) return;
    root.querySelectorAll('.discounts li, li.discount').forEach(function (li) {
      if (li.closest('.vip-line-disc') || li.closest('.vip-sum-row')) return;
      var code = li.getAttribute('data-discount-code') || '';
      var txt = (li.textContent || '').replace(/\s+/g, ' ').trim();
      var hit = isVipTitle(code) || s.titles.some(function (t) { return txt.indexOf(t) > -1; }) || /^VIP (Early Access|Sale|-Day)/i.test(txt);
      if (hit && !/Teppich/i.test(txt)) {
        li.classList.add('vip-hide-pill');
        var ul = li.closest('ul');
        if (ul && !ul.querySelector('li:not(.vip-hide-pill)')) ul.classList.add('vip-hide-pill');
      }
    });
  }
  function paintTotals(root, s) {
    var total = Number(s.cart.total_price);
    root.querySelectorAll('.totals').forEach(function (totals) {
      if (totals.closest('.vip-sum-row')) return;
      var wrap = totals.querySelector('.total_price-wrap');
      var val = wrap || totals.querySelector('.totals__subtotal-value');
      if (!val) return;
      var prev = totals.previousElementSibling;
      var row = prev && prev.classList.contains('vip-sum-row') ? prev : null;
      if (!row) {
        row = document.createElement('div');
        row.className = 'vip-sum-row flex justify-between items-center text-sm font-body-bold';
        row.innerHTML = '<span class="vip-sum-row__lbl inline-flex items-center gap-1">' + ICON + '<span></span></span><span class="vip-sum-row__val"></span>';
        totals.parentNode.insertBefore(row, totals);
      }
      row.querySelector('.vip-sum-row__lbl span').textContent = 'VIP-Rabatt ' + s.label + ' (' + s.pct + ' %)';
      row.querySelector('.vip-sum-row__val').textContent = '−' + fmt(s.disc);
      if (s.real) return; /* echter Rabatt: Zwischensumme ist vom Theme bereits reduziert */
      if (!val.hasAttribute('data-vip-orig')) val.setAttribute('data-vip-orig', val.innerHTML);
      if (wrap) {
        wrap.innerHTML = '<s class="font-body text-sm text-subtext final_price">' + fmt(total) + '</s> <span class="totals__subtotal-value">' + fmt(total - s.disc) + '</span>';
      } else {
        val.innerHTML = '<s class="font-body text-sm text-subtext" style="margin-right:8px">' + fmt(total) + '</s>' + fmt(total - s.disc);
      }
    });
  }
  function roots() {
    var list = [];
    var d = document.getElementById('CartDrawer'); if (d) list.push(d);
    document.querySelectorAll('[id^="MainCart-"], .main-cart, cart-items-component, #main-cart-items, #main-cart-footer').forEach(function (el) {
      if (list.indexOf(el) < 0 && !(d && d.contains(el))) list.push(el);
    });
    return list;
  }
  (function () {
    try {
      var st = document.createElement('style');
      st.textContent = '.vip-hide-pill{display:none !important}';
      document.head.appendChild(st);
    } catch (e) {}
  })();
  var busy = false;
  function paint(cart) {
    if (busy) return; busy = true;
    try {
      var s = state(cart);
      roots().forEach(function (root) {
        restore(root);
        if (!s) return;
        paintLines(root, s);
        hideThemePills(root, s);
        paintTotals(root, s);
      });
    } catch (e) { try { console.warn('[VIP cart-lines]', e); } catch (x) {} }
    busy = false;
  }
  var t;
  function later(cart, ms) { clearTimeout(t); t = setTimeout(function () { paint(cart); }, ms || 60); }
  document.addEventListener('vip:cart', function (e) { later(e.detail && e.detail.cart, 30); });
  document.addEventListener('vip:phase', function () { later(null, 30); });
  document.addEventListener('cart:updated', function () { later(null, 120); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { later(null, 400); });
  else later(null, 400);
})();
